import { Actiontypes } from "../Action/ActionType";
const intialState = {
  profile: {},
  news:false
};

export const UserProfile = (state = intialState, { type, payload }) => {
  switch (type) {
    case Actiontypes.PROFILE:
      return { ...state, profile: payload };
    default:
      return state;
  }
};

export const Newsadd = (state = intialState, { type, payload }) => {
  switch (type) {
    case Actiontypes.NEWS:
      return { ...state, news: payload };
    default:
      return state;
  }
};






